import { useEffect, useState } from "react";
import { useLang } from "@/lib/i18n";
import { Globe, X } from "lucide-react";

const DISMISS_KEY = "rn3.habla.dismissed";

/**
 * Shows a small sticky banner the first time a Spanish-locale browser lands on the
 * English-default site. Clicking "Sí" flips language to ES (persistently). Clicking
 * "Dismiss" or the X never shows the banner again on this device.
 */
const HablaEspanolBanner = () => {
  const { lang, setLang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(DISMISS_KEY) === "1";
      const explicit = localStorage.getItem("rn3.lang");
      if (dismissed || explicit) return;
      const browser = (navigator.language || "").toLowerCase();
      if (browser.startsWith("es") && lang === "en") {
        setVisible(true);
      }
    } catch { /* noop */ }
  }, [lang]);

  if (!visible) return null;

  const accept = () => {
    setLang("es");
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* noop */ }
    setVisible(false);
  };
  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* noop */ }
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-50 shadow-xl"
      data-testid="habla-banner"
    >
      <div className="bg-[#0A0A0A] text-white border border-[#C4A252] p-4 flex items-start gap-3">
        <Globe className="w-5 h-5 text-[#C4A252] shrink-0 mt-0.5" />
        <div className="flex-1 text-sm">
          <div className="font-serif-display text-lg leading-tight">¿Hablas español?</div>
          <p className="text-xs text-white/70 mt-1">
            Atendemos a nuestros clientes en inglés y español. ¿Te gustaría continuar en español?
          </p>
          <div className="mt-3 flex gap-2">
            <button onClick={accept} className="rn3-btn-gold !py-1.5 !px-3 text-xs" data-testid="habla-accept">Sí, en español</button>
            <button onClick={dismiss} className="text-xs underline text-white/70 hover:text-white" data-testid="habla-dismiss">Continue in English</button>
          </div>
        </div>
        <button onClick={dismiss} className="text-white/50 hover:text-white shrink-0" data-testid="habla-close" aria-label="Close">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default HablaEspanolBanner;
